import queryString from 'query-string'

import { isWindowEnv } from 'utils/env.utils'

// TODO: SSR - check usage of getSearchParams on SSR - it can be required param
export const getSearchParams = () => queryString.parse(isWindowEnv() ? window.location.search : '')

export const getRouterSearchParams = (location) => queryString.parse(isWindowEnv() ? location.search : '')

export const setSearchParams = (params: Record<string, any>) => {
  const prevParams = getSearchParams()
  window.location.search = queryString.stringify({ ...prevParams, ...params })
}

export const stringifySearchParams = (params: Record<string, any>, options?: Record<string, any>) =>
  queryString.stringify(params, options)

export const removeSearchParam = (param: string): void => {
  if (!isWindowEnv()) return

  const url = new URL(window.location.href)
  url.searchParams.delete(param)

  window.history.replaceState({}, document.title, url.toString())
}
